module.exports.getQueryStringValue = (key) =>{  
  if(key){
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace("\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
  }
 
} 
 

